module.exports = __webpack_public_path__ + "assets/images/rbyearend-09-desktop.jpg?v=7a12e702";